export default {
    rest_point: 'https://back.enroller.ru/rest',
    api_url: 'https://back.enroller.ru',
    websocket_point: 'wss://sockd.enroller.ru:9000',
    websocket_minutes_too_long_disconnect: 5,
    app_leave_for_imitation_events_minutes: 10,
}
